export default {
    items: [/* see metadata.json */],
    current: null
}